const PARSE_MONTHS = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];

/** Calendar date for a coach slot label (local), or null if unparseable. */
export function parseCoachSlotCalendarDate(label, year) {
  if (!label || typeof label !== 'string') return null;
  const clean = label.replace(/\s*\(.*?\)\s*$/, '').trim();
  const m = clean.match(
    /(?:(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s*)?(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s+(\d{1,2})\s+at\s+(\d{1,2}):(\d{2})\s*(AM|PM)/i
  );
  if (!m) return null;
  const mo = m[1];
  const dy = parseInt(m[2], 10);
  let h = parseInt(m[3], 10);
  const mins = parseInt(m[4], 10);
  const per = m[5].toUpperCase();
  const mi = PARSE_MONTHS.indexOf(mo.toLowerCase());
  if (mi === -1) return null;
  if (per === 'PM' && h !== 12) h += 12;
  if (per === 'AM' && h === 12) h = 0;
  const date = new Date(year, mi, dy, h, mins);
  if (isNaN(date.getTime())) return null;
  return date;
}

/** Drop slot strings whose calendar day is strictly before today (local). Keeps unparseable labels. */
export function filterCoachSlotLabelsFromToday(labels, termLabelForYear) {
  const yr = String(termLabelForYear || '').match(/\d{4}/);
  const year = yr ? parseInt(yr[0], 10) : new Date().getFullYear();
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return labels.filter((label) => {
    const d = parseCoachSlotCalendarDate(label, year);
    if (!d) return true;
    const dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    return dayStart >= startOfToday;
  });
}
